/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from "react";
import { Form } from "react-bootstrap";
// all icons and other images
import { Col, Row } from "react-bootstrap";
import FormLabel from "react-bootstrap/FormLabel";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { ECONOMY_TRAVEL_CLASS, ROUND_TRIP } from "constants/common";
import { ValidateHajjForm } from "./ValidateFlightUser";
import { createInquiry } from "services/flights";
import { errorToast, getErrorObject, successToast } from "utilities/utils";
import { Checkbox } from "antd";
import { addDays } from "date-fns";
import TermsAndAckowledgeCheckbox from "components/common/TermsAndAckowledgeCheckbox";

const initialState = {
  showFromDropDown: null,
  showToDropDown: null,
  sourceStation: null,
  destination: null,
  departure_date: new Date(),
  arrival_date: addDays(new Date(), 10),
  adultCount: 0,
  childCount: 0,
  infantCount: 0,
  travelClass: null,
  tripType: ROUND_TRIP,
  airports: [],
  travellersAndClass: {
    travelClass: ECONOMY_TRAVEL_CLASS,
    noOfTravellerType: [
      {
        type: "adult",
        members: 1,
      },
      {
        type: "children",
        members: 0,
      },
      {
        type: "infant",
        members: 0,
      },
    ],
  },
  full_name: "",
  email: "",
  phone: "+1",
  no_of_rooms: "",
  no_of_travellers: "",
  room_ratings: "",
  no_of_evisa: "",
  nationalities: [],
  passport_type: "",
  no_of_passports: "",
  errors: null,
  multiCities: [],
  isDateFlexible: false,
  isDateFixed: false,
  isUmrahOnly: null,
  isUmrahDubaiPackage: null,
  isUmrahTurkeyPackage: null,
  isCountryEditable: true,
  other_passport_type: "",
  other_passports: [],
  passports: [],
  open: false,
  fromOnway: false,
  isAmericalPassportHolder: false,
  isTermsAccepted: false,
};
export default function HajjInqForm({ mainType, fromSticky }) {
  const [state, setState] = useState(initialState);
  const phoneRef = useRef(null);

  const handleChange = (e, isRoomDropdown) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      errors: {
        ...state.errors,
        [e.target.name]: null,
      },
    });
  };

  const handlePhoneChange = (e) => {
    // let value = e.target.value
    //   .replaceAll("(", "")
    //   .replaceAll(")", "")
    //   .replaceAll(" ", "")
    //   .replaceAll("_", "")
    //   .replaceAll("-", "");
    console.log("value", e);
    setState({
      ...state,
      phone: `${e}`,
      errors: {
        ...state.errors,
        phone: null,
      },
    });
  };

  const submitFlightSearch = async (e) => {
    // console.log("state", state);
    // next();
    e.preventDefault();
    setState({ ...state, submitting: true });

    let data = {
      full_name: state.full_name,
      email: state.email,
      phone: state.phone,
      mainType: mainType === "hajj_inq" ? "HajjInquiry" : "umrahInquiry",
      no_of_travellers: state.no_of_travellers,
      isAmericalPassportHolder: state.isAmericalPassportHolder,
      isUmrahOnly: state.isUmrahOnly,
      isUmrahDubaiPackage: state.isUmrahDubaiPackage,
      isUmrahTurkeyPackage: state.isUmrahTurkeyPackage,
      isTermsAccepted: state.isTermsAccepted,
    };
    const errors = ValidateHajjForm(data);
    if (!errors.isValid) {
      setState({ ...state, errors: errors.errors, submitting: false });
    } else {
      let extraOptions = {};
      if (mainType !== "hajj_inq") {
        if (state.isUmrahOnly) {
          extraOptions = {
            extra_option: "Umrah Only",
          };
        }
        if (state.isUmrahDubaiPackage) {
          extraOptions = {
            extra_option: "Umrah with Dubai Package",
          };
        }
        if (state.isUmrahTurkeyPackage) {
          extraOptions = {
            extra_option: "Umrah with Turkey Package",
          };
        }
      }
      let payload = {
        type: mainType === "hajj_inq" ? "HajjInquiry" : "umrahInquiry",
        fullName: state.full_name,
        email: state.email,
        mobileNumber: state.phone,
        totalTravellers: state.no_of_travellers,
        ...extraOptions,
        // isAmericanPassportHolder: state.isAmericalPassportHolder,
      };

      try {
        let inquiryResponse = await createInquiry(payload);
        if (inquiryResponse.data.success) {
          successToast({
            content:
              "Inquiry submitted successfully , you will get an update soon from us",
          });
          //   next();
          // } else {
          //   dispatch({
          //     type: "ON_SET_TRIP_DETAILS",
          //     payload: inquiryResponse.data.data,
          //   });
          //   navigate(appRoutesConst.searchflight);
          // }
          setState({ ...state, submitting: false });
        }
        await setState({ ...initialState });
      } catch (e) {
        let { message } = getErrorObject(e);
        errorToast({
          content: message,
        });
        await setState({ ...state, submitting: false });
      }
    }
  };

  const handleCheckbox = (e, name) => {
    if (name === "isUmrahOnly") {
      setState({
        ...state,
        isUmrahOnly: e.target.checked,
        isUmrahDubaiPackage: false,
        isUmrahTurkeyPackage: false,
        errors: {
          date_fix_flexi: null,
        },
      });
    }
    if (name === "isUmrahDubaiPackage") {
      setState({
        ...state,
        isUmrahOnly: false,
        isUmrahDubaiPackage: e.target.checked,
        isUmrahTurkeyPackage: false,
        errors: {
          date_fix_flexi: null,
        },
      });
    }
    if (name === "isUmrahTurkeyPackage") {
      setState({
        ...state,
        isUmrahOnly: false,
        isUmrahDubaiPackage: false,
        isUmrahTurkeyPackage: e.target.checked,
        errors: {
          date_fix_flexi: null,
        },
      });
    }
  };

  return (
    <div className={`user-details ${fromSticky ? "sticky-div" : ""}`}>
      <div className="user-details-title position-relative">
        {!fromSticky && (
          <p className="position-relative font-weight-semibold user-border mb-0">
            User’s Details
          </p>
        )}
        {fromSticky && (
          <p className="position-relative text-center font-weight-semibold user-border mb-0">
            Umrah Inquiry
          </p>
        )}
      </div>
      <div>
        {/* <div class="alert alert-danger text-center" role="alert">
          <a href="#" class="alert-link ">
            <sup>*</sup>
            Before you fill Hajj Inquiry form make sure all travelers should be
            an American Passport Holder Only
          </a>
        </div> */}
        <div
          className={`user-detail-search-form ${
            fromSticky ? "sticky-form" : ""
          }`}
        >
          <Row className="g-3">
            <Col md className={`${fromSticky ? "" : "mb-md-4 mb-3"}`}>
              <FormLabel controlId="floatingInputGrid">
                <Form.Control
                  name="full_name"
                  onChange={handleChange}
                  value={state.full_name}
                  type="text"
                  placeholder="Enter Full Name"
                />
              </FormLabel>
              {state.errors && (
                <span className="text-danger">{state.errors.full_name}</span>
              )}
            </Col>
            <Col md className={`${fromSticky ? "" : "mb-md-4 mb-2"}`}>
              {/* <FormLabel
                  controlId="floatingInputGrid"
                  // label="Phone number"
                > */}
              {/* <Form.Control
                    type="text"
                    name="phone"
                    onChange={handleChange}
                    value={state.phone}
                    placeholder="Enter phone number"
                  /> */}
              {(state.phone === "" ||
                state.phone === "+1" ||
                state.phone === "1") && (
                <label
                  onClick={() => {
                    console.log(
                      "phoneref",
                      phoneRef.current.numberInputRef.focus()
                    );
                  }}
                  // style={{ top: "28%" }}
                  className={`${
                    fromSticky ? "phone-lable sticky-phone-lbl" : "phone-lable"
                  }`}
                >
                  (324) 242-3423
                </label>
              )}
              <PhoneInput
                country={"us"}
                preferredCountries={["us", "ca"]}
                inputClass={`form-contorl ${
                  fromSticky ? "form-contorl-sticky" : ""
                }`}
                containerClass={`${fromSticky ? "dropdown-class-sticky" : ""}`}
                countryCodeEditable={state.isCountryEditable}
                onChange={(d) => {
                  console.log("ddd", d);
                  handlePhoneChange(d);
                }}
                placeholder="+1 (324) 242-3423"
                onFocus={() => setState({ ...state, isCountryEditable: false })}
                // disableCountryCode
                value={state.phone}
                ref={phoneRef}
              />
              {state.errors && (
                <span className="text-danger">{state.errors.phone}</span>
              )}
            </Col>
          </Row>
          <Row className="g-3">
            <Col md className={`${fromSticky ? "" : "mb-md-4 mb-2"}`}>
              <FormLabel
                controlId="floatingInputGrid"
                // label="Email address"
              >
                <Form.Control
                  type="text"
                  name="email"
                  onChange={handleChange}
                  value={state.email}
                  placeholder="Enter Email Address"
                />
              </FormLabel>
              {state.errors && (
                <span className="text-danger">{state.errors.email}</span>
              )}
            </Col>
            <Col md className={`${fromSticky ? "" : "mb-md-4 mb-2"}`}>
              <FormLabel controlId="floatingInputGrid">
                <Form.Control
                  name="no_of_travellers"
                  onChange={handleChange}
                  value={state.no_of_travellers}
                  type="text"
                  placeholder="Enter Total No Of Travellers"
                />
              </FormLabel>
              {state.errors && (
                <span className="text-danger">
                  {state.errors.no_of_travellers}
                </span>
              )}
            </Col>
          </Row>
          <Row className="g-3">
            <div className="dates-checkbox-container">
              <Checkbox
                onChange={(e) => handleCheckbox(e, "isUmrahOnly")}
                className="date-checkbox "
                checked={state.isUmrahOnly}
              >
                Umrah Only
              </Checkbox>
              <Checkbox
                onChange={(e) => handleCheckbox(e, "isUmrahDubaiPackage")}
                className="date-checkbox "
                checked={state.isUmrahDubaiPackage}
              >
                Umrah with Dubai Package
              </Checkbox>
              <Checkbox
                onChange={(e) => handleCheckbox(e, "isUmrahTurkeyPackage")}
                className="date-checkbox "
                checked={state.isUmrahTurkeyPackage}
              >
                Umrah with Turkey Package
              </Checkbox>
            </div>
            {state.errors && (
              <span className="text-danger">{state.errors.otherPackages}</span>
            )}
          </Row>
          <Row>
            <TermsAndAckowledgeCheckbox
              handleCheckbox={(e) => {
                setState({
                  ...state,
                  isTermsAccepted: e.target.checked,
                  errors: { ...state.errors, isTermsAccepted: null },
                });
              }}
              isTermsAccepted={state?.isTermsAccepted}
              errors={state.errors}
            />
          </Row>
          {/* <Row className="g-3">
            <Checkbox
              onChange={(e) => {
                setState({
                  ...state,
                  isAmericalPassportHolder: e.target.checked,
                  errors: {
                    ...state.errors,
                    isAmericalPassportHolder: null,
                  },
                });
              }}
              className="date-checkbox"
              checked={state?.isAmericalPassportHolder}
            >
              {" "}
              Yes I am / We are American passport holder(s)
            </Checkbox>
            {state.errors && (
              <span className="text-danger">
                {state.errors.isAmericalPassportHolder}
              </span>
            )}
          </Row> */}
        </div>
        <div
          className={`search-button position-relative text-center mt-0 hajj-inquiry-tab ${
            fromSticky ? "sticky-btn" : ""
          }`}
        >
          <button
            // onClick={() =>
            //   // navigate(appRoutesConst.searchflight)
            className="btn btn-primary"
            onClick={submitFlightSearch}
          >
            {state.submitting ? (
              <span>
                <span>Submitting ...</span>{" "}
              </span>
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
